import { render, staticRenderFns } from "./ODoServerActionButton.vue?vue&type=template&id=5a773335&scoped=true&"
import script from "./ODoServerActionButton.vue?vue&type=script&lang=js&"
export * from "./ODoServerActionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a773335",
  null
  
)

export default component.exports